<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Active users</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/locked/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        Locked users
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/deleted/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-user-times" aria-hidden="true"></i>
                        Deleted users
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/service-accounts/${tid}`" class="btn btn-link btn-sm">
                        <i class="fa fa-cog" aria-hidden="true"></i>
                        Service accounts
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <a :href="`/#/admin/organizations/users/create/${tid}`" role="button" class="btn btn-success text-white" style="padding: 0.7em 2em;">
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                        Add user
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <UsersTable v-if="users.length" :users="users"></UsersTable>
            <h4 v-else>No active users</h4>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted } from 'vue'
    import { useRoute } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import UsersTable from '@Organizations/Users/Components/UsersTable.vue'

    import { useSearchAllUsersQueryV1 } from '@Organizations/Users/queries-vue-composables'

    const route = useRoute()
    const tid = computed(() => Number(route.params.tid))

    const { 
        runSearchAllUsersQueryV1, 
        modelSearchAllUsersQueryV1: allUsersSearchResult 
    } = useSearchAllUsersQueryV1(tid, '', true, false, false)

    const users = computed(() => allUsersSearchResult.value?.Users ?? [])

    onMounted(() =>
    {
        document.title = 'Active users'
        runSearchAllUsersQueryV1()
    })
</script>

